import React from 'react'; 
import { Routes, Route } from "react-router-dom";
import Company from '../pages/Company/Company';
import Landingpage from '../pages/Landing/Landingpage';
import Merchant from '../pages/Merchant/Merchant';
import CompanyFromstep from '../pages/Company/CompanyFromstep';
import Success from '../pages/Registation/Success';
import OTPVerifier from '../pages/auth/OTPVerifier';
import Addorganization from '../pages/Merchant/Addorganization';
import DashboardLayout from '../pages/Dashbord/DashboardLayout';
import Dashbord from '../pages/Dashbord/Dashbord';
import MemberManagement from '../pages/Dashbord/pages/Membermange/MemberManagement';
import CompanyManagement from '../pages/Dashbord/pages/Companymanage/CompanyManagement';
import Gstpage from '../pages/Company/Gstpage';
import Gstform from '../pages/Company/Gstform';
import KYCDetailsForm from '../pages/Company/KYCDetailsForm';
import Prevstatus from '../pages/Company/Prevstatus';
import LoginScreen from '../pages/auth/LoginScreen';
import Companyprocess from '../pages/Dashbord/pages/Companymanage/Companyprocess';
import Kycprocess from '../pages/Dashbord/pages/Companymanage/Kycprocess';
import PersonalDetailsProcess from '../pages/Dashbord/pages/Companymanage/PersonalDetailsProcess';
import Marchantonbord from '../pages/Merchant/Marchantonbord';
import MarchnatFromstep from '../pages/Merchant/MarchnatFromstep';
import KYCDetailsFormMr from '../pages/Merchant/KYCDetailsFormMr';
import Mrlist from '../components/list/Mrlist';
import Businesspartner from '../components/list/Businesspartner';
import MemberDocumentProcess from '../pages/Dashbord/pages/Membermange/MemberProcess';
import AdminInfo from '../pages/Company/AdminInfo';


  const Router = () => {
  return (
    <Routes> 
    <Route path="/" element ={<Landingpage/>}/>
    <Route path="otppage" element ={<OTPVerifier/>}/>
    <Route path="companyPage" element ={<Company/>}/>
    <Route path="companypagestep" element ={<CompanyFromstep/>}/>
    <Route path="merchantPage" element ={<Merchant/>}/>
    <Route path="successpage" element ={<Success/>}/>
    <Route path="addorganization" element ={<Addorganization/>}/>
    <Route path="gstpage" element ={<Gstpage/>}/>
    <Route path="gstformpage" element ={<Gstform/>}/> 
    <Route path="kydetailsform" element={<KYCDetailsForm/>} />
    <Route path="prevstatus" element={<Prevstatus/> }/>
    <Route path="loginscreen" element={<LoginScreen/>} />
    <Route path="marchantonbordpage" element={<Marchantonbord/>} />
    <Route path="marchantpagestep" element ={<MarchnatFromstep />}/>
    <Route path="kydetailsmarchantform" element ={<KYCDetailsFormMr/>}/>
    <Route element={<DashboardLayout />}>
    <Route path="dashboard" element={<Dashbord/>} />
    <Route path="membermanagement" element={<MemberManagement/>} />
    <Route path="marchantmanagement" element={<Businesspartner/>} />
    <Route path="companymanagement" element={<CompanyManagement/>} />
    <Route path="adminInfo" element={<AdminInfo/>} />
    <Route path="MemberDocumentProcess" element={<MemberDocumentProcess/>} />
    <Route path="copanyprocess" element={<Companyprocess />}/> 
    <Route path="kyc-process" element={<Kycprocess />}/> 
    <Route path="personal-details" element={< PersonalDetailsProcess />}/> 
    </Route>
    <Route path="*" element={<h2>404 - Page Not Found</h2>} />
   </Routes>
  )
  }
  export default Router; 



